export default __webpack_public_path__ + "static/media/intrvl_line_logo_black.5d872287.svg";